/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'brand/NG_ACCOUNT_FILLED': {
    width: 16,
    height: 16,
    viewBox: '0 0 68 100',
    data: '<path pid="0" _fill="currentColor" d="M44.59 38.21l.37-.27c3.54-2.73 7.35-6.4 8.71-12.86 1.09-5.19-.61-10.55-1.39-12.61a18.26 18.26 0 0 0-9.56-10.25A20.47 20.47 0 0 0 34.3.39c-8.52-.06-16 4.76-18.93 12.27-3.28 8.27-1.94 15.74 4 22.21 6.69 7.32 17.78 8.79 25.25 3.34M61 62.64c-3.2-7.56-10.28-11.43-17.45-14.48-5.4-2.3-10.52-1.7-15.48-1.12-.59.07-1.19.12-1.79.18-2.94.27-6.28.58-9.38 2.36-3.9 2.24-5.9 6.13-7.45 9.26l-.5 1a38.76 38.76 0 0 0-3.74 11.51 9.05 9.05 0 0 1-.7 2.51 16.87 16.87 0 0 0-1.18 4.27c-.08.57-.25 1.22-.42 1.92-.58 2.3-1.37 5.45.11 8.64 1.61 3.49 5.88 6.22 12.69 8.12 5.69 1.59 11.62 2.09 17.35 2.57h.48c1.44.13 2.89.19 4.33.19a51.49 51.49 0 0 0 9.83-1c6-1.18 14.46-7.8 17.74-12.63 1-1.44-.22 1.72 0 0 .85-6.71-.6-14.36-4.41-23.39"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/brand/NG_ACCOUNT_FILLED.js